import { render, staticRenderFns } from "./ManteBazarUsuario.vue?vue&type=template&id=94c370f8&"
import script from "./ManteBazarUsuario.vue?vue&type=script&lang=js&"
export * from "./ManteBazarUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports